import DebtorType from '../constants/DebtorType';

export default class DriveBilling {
  id!: number;
  dealerCustomerDataId: number | null = null;
  debtorType: DebtorType | null = null;
  billingPart!: number;
  billingPartAmount!: number;
  isBillingPercentage!: boolean;
  isInvoiced!: boolean;
  isDeleted!: boolean;
}
